export default (theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  titleCard: {
    marginBottom: 7,
    width: '100%',
  },
  listContainer: {
    width: '100%',
  },
  itemContainer: {
    borderTop: '1px solid #707070',
    padding: theme.spacing(2, 2, 0, 2),

    '&:first-child': {
      borderTop: 0,
    },
  },
  itemContainerInfo: {
    display: 'flex',
  },
  itemContainerInfoTypography: {
    fontSize: theme.typography.pxToRem(14),
    margin: theme.spacing(1, 0),

    '&:first-child': {
      flex: 1,
      marginRight: theme.spacing(1),
    },

    '&:last-child': {
      flex: 1,
      textAlign: 'center',
    },
  },
  itemContainerInfoTypographyRight: {
    '&:last-child': {
      textAlign: 'right',
    },
  },
  itemCell: {
    display: 'flex',
    margin: theme.spacing(0.5, 0),
  },
  itemCellRight: {
    justifyContent: 'flex-end',
  },
  itemCellCenter: {
    justifyContent: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.spacing(2),
  },
  selectedCheckboxContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  selectedAllCheckboxContainer: {
    display: 'flex',
    marginRight: theme.spacing(2),
  },
  selectedAllCheckboxTypography: {
    fontSize: theme.typography.pxToRem(14),
  },
  containerLoading: {
    margin: 'auto',
  },
});
